import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Box, Button, useTheme } from "@mui/material";
import { DarkModeOutlined, LightModeOutlined, LogoutOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setMode } from "state";
import { logout } from "state/authSlice";
import { deriveRole } from "state/RoleBasedRoute";
import FlexBetween from "./FlexBetween";
import foliregLogo   from "../assets/Folireg.png";
import bisberryLogo  from "../assets/Bisberry.png";
import endocareLogo  from "../assets/Endocare.png";
import lycoredLogo   from "../assets/Lycored-M.png";

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { user } = useSelector((state) => state.auth);
  const role = deriveRole(user?.role);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const mrLinks = [
    { label: "Dashboard",  path: "/mr/dashboard" },
    { label: "Rx",         path: "/mr/rx-tracker",      logo: foliregLogo,  alt: "Folireg" },
    { label: "Weekly",     path: "/mr/weekly-tracker",  logo: bisberryLogo, alt: "Bisberry" },
    { label: "PSP",        path: "/mr/psp-tracker",     logo: endocareLogo, alt: "Endocare" },
    { label: "",           path: "/mr/lycored-tracker", logo: lycoredLogo,  alt: "Lycored M" },
    { label: "My Data",    path: "/mr/my-submissions" },
  ];

  const amLinks = [
    { label: "Dashboard", path: "/am/dashboard" },
    { label: "My MRs", path: "/am/mr-list" },
  ];

  const adminLinks = [
    { label: "Dashboard", path: "/admin/dashboard" },
    { label: "Users", path: "/admin/users" },
    { label: "Submissions", path: "/admin/submissions" },
    { label: "Exports", path: "/admin/exports" },
  ];

  const links = role === "MR" ? mrLinks : role === "AM" ? amLinks : role === "Admin" ? adminLinks : [];

  return (
    <AppBar position="sticky" sx={{ background: theme.palette.background.paper, boxShadow: "0 1px 4px rgba(0,0,0,0.1)" }}>
      <Toolbar>
        <Typography variant="h5" fontWeight="700" color="primary" sx={{ mr: 3 }}>
          NAARI
        </Typography>

        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", flex: 1 }}>
          {links.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Button
                key={link.path}
                size="small"
                onClick={() => navigate(link.path)}
                variant={active ? "contained" : "text"}
                sx={{
                  textTransform: "none",
                  fontSize: "0.75rem",
                  minWidth: "auto",
                  px: link.logo ? 1 : 1.5,
                  py: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                {link.logo && (
                  <Box
                    component="img"
                    src={link.logo}
                    alt={link.alt}
                    sx={{
                      height: 22,
                      width: "auto",
                      objectFit: "contain",
                      display: "block",
                      filter: active ? "brightness(0) invert(1)" : "none",
                      transition: "filter 0.2s",
                    }}
                  />
                )}
                {link.label}
              </Button>
            );
          })}
        </Box>

        <FlexBetween gap={1}>
          <Typography variant="caption" color="textSecondary" sx={{ display: { xs: "none", sm: "block" } }}>
            {user?.username} ({role})
          </Typography>
          <IconButton onClick={() => dispatch(setMode())}>
            {theme.palette.mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
          </IconButton>
          <IconButton onClick={handleLogout} color="error">
            <LogoutOutlined />
          </IconButton>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
